import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { ChevronDown } from 'lucide-react';

import { filterBusinessValueRows } from '@/lib/businessValueCategories';



function formatMoney(n, decimals = 2) {

  return `$${Number(n || 0).toLocaleString(undefined, {

    minimumFractionDigits: decimals,

    maximumFractionDigits: decimals,

  })}`;

}



function reductionPct(manual, llm) {

  if (!manual || manual <= 0) {

    return 0;

  }

  return ((manual - llm) / manual) * 100;

}



export default function SavingsComparisonTable({ savings }) {

  const rows = filterBusinessValueRows(savings?.by_ticket_type || []).filter(

    (row) => row.manual_cost > 0 || row.llm_cost > 0 || row.ticket_count > 0,

  );



  if (!rows.length) {

    return (

      <Card>

        <CardContent className="py-8 text-center text-sm text-muted-foreground">

          No ticket data in this range.

        </CardContent>

      </Card>

    );

  }



  const totalManual = savings.total_manual_cost ?? 0;

  const totalLlm = savings.total_llm_cost ?? 0;

  const totalSaved = savings.total_savings ?? 0;

  const totalReduction = reductionPct(totalManual, totalLlm);



  return (

    <Card data-testid="bv-comparison-table">

      <CardHeader>

        <CardTitle>Cost to resolve — manual vs LLM</CardTitle>

      </CardHeader>

      <CardContent className="overflow-x-auto">

        <table className="w-full min-w-[640px] text-sm">

          <thead>

            <tr className="border-b text-left text-xs uppercase tracking-wide text-muted-foreground">

              <th className="pb-3 pr-4 font-semibold">Ticket type</th>

              <th className="pb-3 pr-4 text-right font-semibold text-cp-mod">Manual cost</th>

              <th className="pb-3 pr-4 text-right font-semibold text-cp-indigo">LLM cost</th>

              <th className="pb-3 pr-4 text-right font-semibold text-cp-ok">Saved</th>

              <th className="pb-3 text-center font-semibold text-cp-ok">Reduction</th>

            </tr>

          </thead>

          <tbody>

            {rows.map((row) => {

              const rowReduction = reductionPct(row.manual_cost, row.llm_cost);



              return (

                <tr key={row.ticket_type_key} className="border-b last:border-0">

                  <td className="py-4 pr-4">

                    <div className="font-semibold">{row.display_name}</div>

                    {row.estimated_hours > 0 && (

                      <div className="text-xs text-muted-foreground">

                        {row.estimated_hours} hrs × {formatMoney(row.hourly_bill_rate)}/hr

                        {row.ticket_count > 0 && (

                          <span>

                            {' '}

                            · {row.ticket_count} ticket{row.ticket_count === 1 ? '' : 's'}

                          </span>

                        )}

                      </div>

                    )}

                  </td>

                  <td className="py-4 pr-4 text-right font-semibold tabular-nums text-cp-mod">

                    {formatMoney(row.manual_cost)}

                  </td>

                  <td className="py-4 pr-4 text-right font-semibold tabular-nums text-cp-indigo">

                    {formatMoney(row.llm_cost, row.llm_cost < 1 ? 4 : 2)}

                  </td>

                  <td className="py-4 pr-4 text-right font-semibold tabular-nums text-cp-ok">

                    {formatMoney(row.savings)}

                  </td>

                  <td className="py-4 text-center">

                    <span className="inline-flex items-center gap-1 rounded-full border border-cp-line bg-cp-inset px-2.5 py-1 text-xs font-bold text-cp-ok">

                      <ChevronDown className="h-3 w-3" />

                      {rowReduction.toFixed(2)}%

                    </span>

                  </td>

                </tr>

              );

            })}

            <tr className="border-t-2">

              <td className="py-4 pr-4 font-bold">

                All ticket types

                <div className="text-xs font-normal text-muted-foreground">

                  {savings.ticket_count} ticket{savings.ticket_count === 1 ? '' : 's'}

                </div>

              </td>

              <td className="py-4 pr-4 text-right font-bold tabular-nums text-cp-mod">

                {formatMoney(totalManual)}

              </td>

              <td className="py-4 pr-4 text-right font-bold tabular-nums text-cp-indigo">

                {formatMoney(totalLlm, totalLlm < 1 ? 4 : 2)}

              </td>

              <td className="py-4 pr-4 text-right font-bold tabular-nums text-cp-ok">

                {formatMoney(totalSaved)}

              </td>

              <td className="py-4 text-center">

                <span className="inline-flex items-center gap-1 rounded-full border border-cp-line bg-cp-inset px-2.5 py-1 text-xs font-bold text-cp-ok">

                  <ChevronDown className="h-3 w-3" />

                  {totalReduction.toFixed(2)}%

                </span>

              </td>

            </tr>

          </tbody>

        </table>

      </CardContent>

    </Card>

  );

}

